import * as React from 'react';
/**
 *
 * Original name: finder
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A341
 *
 */
export const FinderPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M10 11v42h44V11H10Zm4 4h16v19h8.971c-.281 4.729-2.622 7.125-6.971 7.125-4.029 0-6.333-2.06-6.873-6.125h-4.013c.675 6.376 4.63 10.125 10.886 10.125a10.96 10.96 0 0 0 7-2.219V49H14V15Zm36 34h-7V30h-9V15h16v34Z", fill: "currentColor" }),
    React.createElement("path", { d: "M26 23a2.706 2.706 0 0 0-3-3 2.706 2.706 0 0 0-3 3 2.706 2.706 0 0 0 3 3 2.706 2.706 0 0 0 3-3Zm15 3a2.706 2.706 0 0 0 3-3 2.706 2.706 0 0 0-3-3 2.706 2.706 0 0 0-3 3 2.706 2.706 0 0 0 3 3Z", fill: "currentColor" })));
